import { Box, Button, LinearProgress, Stack } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useGetPricesByProductQuery } from "src/api/services/productsApi";
import { MatchParam } from "src/constants/matches";
import { useManageModal } from "src/hooks/useManageModal";
import CreatePriceModal from "./components/CreatePriceModal";
import DataTable from "src/components/DataTable";
import { useColumns } from "./useColumns";
import { useMemo } from "react";

const ProductPrices = () => {
  const { productId } = useParams<MatchParam<"PRODUCT_ID">>();
  const { data = [], isFetching } = useGetPricesByProductQuery(
    productId != null ? { slug: productId } : skipToken,
  );
  const [open, { handleClose, handleOpen }] = useManageModal();
  const columns = useColumns();
  const height = useMemo(() => window.innerHeight - 104 - 64 - 34, []);

  return (
    <Stack gap={2} sx={{ width: "100%" }}>
      <Button
        sx={{ width: "fit-content", alignSelf: "end" }}
        onClick={handleOpen}
      >
        + Add Price
      </Button>
      <Stack gap={0} sx={{ width: "100%" }}>
        <Box height={4}>{isFetching ? <LinearProgress /> : null}</Box>
        <DataTable
          columns={columns}
          data={data}
          primaryKey="id"
          height={height}
        />
      </Stack>

      <CreatePriceModal open={open} onClose={handleClose} />
    </Stack>
  );
};

export default ProductPrices;
